import type {TFunction} from 'i18next';
import {
  SECTION_ORDER,
  type VelaCard,
  type VelaContent,
  type VelaContext,
  type VelaRule,
  type VelaSectionId,
} from './types';

export function buildVelaContent(
  ctx: VelaContext,
  t: TFunction,
  rules: VelaRule[],
): VelaContent {
  const buckets = new Map<VelaSectionId, {priority: number; card: VelaCard}[]>();

  for (const rule of rules) {
    if (!rule.scenes.includes(ctx.scene)) continue;
    const card = rule.evaluate(ctx, t);
    if (!card) continue;

    const bucket = buckets.get(rule.section) ?? [];
    bucket.push({priority: rule.priority ?? 0, card});
    buckets.set(rule.section, bucket);
  }

  const sections = SECTION_ORDER.flatMap(({id, labelKey, cap}) => {
    const bucket = buckets.get(id);
    if (!bucket?.length) return [];

    const cards = bucket
      .sort((a, b) => b.priority - a.priority)
      .slice(0, cap)
      .map(entry => ({...entry.card, priority: entry.priority}));
    const label = typeof labelKey === 'function' ? labelKey(ctx) : labelKey;

    return [{id, label: t(label), cards}];
  });

  return {sections};
}
